jQuery(document).ready(function() {
   jQuery('.collection-roundells').slick({
     dots: false,
     speed: 500,
     infinite:false,
    arrows:true,
     slidesToShow: 9,
     slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6
      }
    },
           {
      breakpoint: 1001,
      settings: {
        slidesToShow: 5
      }
    },
       {
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.5
      }
    }
  ]
   });
 });





$(document).ready(function(){


		jQuery('#southwood_usp').slick({
			dots: false,
			infinite: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
                {
				breakpoint: 1000,
				settings: {
					slidesToShow: 3
				}
			},
                {
				breakpoint: 750,
				settings: {
					slidesToShow: 2
				}
			},
            {
				breakpoint: 500,
				settings: {
					slidesToShow: 1
				}
			}]
		});	
});

/* Southwood collection scroll restoration for clean product URLs
   Keeps /products/... links in collection grids while restoring the customer's position
   when they return to a collection page. */
(function () {
  var STORAGE_PREFIX = 'southwood_collection_scroll_v1:';
  var MAX_AGE_MS = 4 * 60 * 60 * 1000; // 4 hours

  function isCollectionPage() {
    return document.body && document.body.classList.contains('template-collection');
  }

  function collectionKey() {
    return STORAGE_PREFIX + window.location.pathname + window.location.search;
  }

  function saveCollectionPosition() {
    if (!isCollectionPage()) return;
    try {
      sessionStorage.setItem(collectionKey(), JSON.stringify({
        x: window.pageXOffset || document.documentElement.scrollLeft || 0,
        y: window.pageYOffset || document.documentElement.scrollTop || 0,
        time: Date.now()
      }));
    } catch (e) {}
  }

  function restoreCollectionPosition() {
    if (!isCollectionPage()) return;

    var raw;
    try {
      raw = sessionStorage.getItem(collectionKey());
    } catch (e) {
      return;
    }
    if (!raw) return;

    var saved;
    try {
      saved = JSON.parse(raw);
    } catch (e) {
      return;
    }

    if (!saved || typeof saved.y !== 'number' || saved.y <= 0) return;
    if (saved.time && Date.now() - saved.time > MAX_AGE_MS) {
      try { sessionStorage.removeItem(collectionKey()); } catch (e) {}
      return;
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var attempts = 0;
    var maxAttempts = 16;

    function tryRestore() {
      attempts += 1;
      window.scrollTo(saved.x || 0, saved.y);

      if (attempts < maxAttempts && Math.abs((window.pageYOffset || 0) - saved.y) > 8) {
        window.setTimeout(tryRestore, attempts < 6 ? 120 : 250);
      }
    }

    window.setTimeout(tryRestore, 0);
    window.setTimeout(tryRestore, 300);
    window.setTimeout(tryRestore, 800);
    window.setTimeout(tryRestore, 1500);
  }

  document.addEventListener('click', function (event) {
    if (!isCollectionPage()) return;
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link) return;
    saveCollectionPosition();
  }, true);

  window.addEventListener('pagehide', saveCollectionPosition);
  window.addEventListener('beforeunload', saveCollectionPosition);
  window.addEventListener('pageshow', restoreCollectionPosition);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCollectionPosition);
  } else {
    restoreCollectionPosition();
  }
})();